import { ColorChooserPopUp } from "./ColorChooserPopUp";
import bindAllOfThis from "src/utils/BindThisHelper";
import { MainScene } from "./MainScene";

export class ColorChooserPopUpScene extends Phaser.Scene {
    gameWidth: number;
    gameHeight: number;
    colorType: "primary" | "secondary" | "tertiary";

    constructor(colorType, num) {
        super({
            key: "ColorChooserPopUp_" + num, // So that we have unique scene names
        });

        bindAllOfThis(this, ColorChooserPopUpScene.prototype);
        this.colorType = colorType;
    }

    create() {
        this.gameWidth = this.textures.game.config.width as number;
        this.gameHeight = this.textures.game.config.height as number;

        var popup = new ColorChooserPopUp(this, this.gameWidth / 2, this.gameHeight / 2);
        popup.on('choseColor', (color: number) => {
            popup.destroy();
            // Hacky way of calling a method in another scene!
            var mainScene = this.scene.get("MainScene") as MainScene;
            mainScene.changeColor(this.colorType, color);
        });
    }

}




// WEBPACK FOOTER //
// ./src/games/UniformDesignGame/scenes/ColorChooserPopUpScene.ts